import React from 'react';
import CoWorkChatVisual from './CoWorkChatVisual';
import SectionSurface from '../../shared/SectionSurface';
import { getMedia } from '../../../../content/productMedia';

const PREFERRED_CLIPS = [
  'cowork_clip1',
  'cowork_clip2',
  'cowork_clip3',
  'cowork_clip4',
  'cowork_clip5',
  'cowork_clip6',
  'cowork_clip7',
  'cowork_clip8',
];

const QUADRANT_TARGET = 8;

/** Fill an 8-slot grid from available clips; duplicate when fewer than eight exist locally. */
function buildQuadrantClips() {
  const available = PREFERRED_CLIPS.filter((id) => getMedia(id));
  if (available.length === 0) return [];

  const clips = [];
  for (let i = 0; i < QUADRANT_TARGET; i += 1) {
    clips.push({ id: available[i % available.length], key: `cowork-quadrant-${i}` });
  }
  return clips;
}

export default function CoWorkShowcase() {
  const clips = buildQuadrantClips();

  return (
    <SectionSurface
      as="section"
      id="cowork-showcase"
      variant="accent-semantic"
      decor="rings"
      connectTo="purple"
      bleed="both"
      flowTop
      flowBottom
      overlap
      className="scroll-mt-24 !pt-6 sm:!pt-8"
    >
      <div className="container-x pb-10 sm:pb-12 lg:pb-14">
        <div className="max-w-3xl mx-auto text-center lg:mx-0 lg:text-left">
          <p className="eyebrow">Snowflake CoWork</p>
          <h2 className="mt-3 text-3xl font-semibold tracking-tight text-ink-900 sm:text-4xl">
            Conversational analytics in the agent workspace
          </h2>
          <p className="mt-4 text-base leading-relaxed text-ink-600">
            Governed Cortex agents in action. Each tile replays a real Semantic HR query flow. Split-screen product
            media lives on{' '}
            <a href="/semantic-hr" className="font-medium text-brand-600 hover:text-brand-700">
              Semantic HR
            </a>
            .
          </p>
        </div>

        <div className="mx-auto mt-6 grid max-w-5xl grid-cols-2 gap-2.5 sm:grid-cols-4 sm:gap-3">
          {clips.map(({ id, key }, index) => (
            <div
              key={key}
              className="aspect-square overflow-hidden rounded-xl border border-ink-200/80 bg-white shadow-sm"
            >
              <CoWorkChatVisual scenarioId={id} compact showComposer={false} playbackOffsetMs={index * 420} />
            </div>
          ))}
        </div>
      </div>
    </SectionSurface>
  );
}
